export class LocalStorageKeys {
  static readonly LASTEST_SEARCHES = "LastestSearches";
  static readonly ALL_VEHICLE_MODELS = "AllVehicleModels";
  static readonly ALL_STATES = "AllStates";
  static readonly SELECTED_STATE = "SELECTED_STATE";
}
